import { Css } from "@homebound/beam";

export function ReviewAndDownloadStep() {
  return (
    <div css={Css.df.fdc.aic.mt6.$}>
      <div css={Css.xl2.$}>Review and Download</div>
      <div css={Css.md.pt2.gray700.$}>Coming soon</div>
    </div>
  );
}
